<form novalidate [formGroup]="changePassForm" #cpform="ngForm" (ngSubmit)="save()">
  <div class="p-5">
    <mat-form-field class="full-width-input" appearance="outline">
      <mat-label class="text-field">Contraseña Antigua</mat-label>
      <input matInput formControlName="oldPassword" type="password" name="oldPassword" required autocomplete="off">
      <mat-error *ngIf="formErrors.oldPassword">{{formErrors.oldPassword}}</mat-error>
    </mat-form-field>
    <mat-form-field class="full-width-input" appearance="outline">
      <mat-label class="text-field">Contraseña Nueva</mat-label>
      <input matInput formControlName="newPassword" type="password" name="newPassword" required autocomplete="off">
      <mat-error *ngIf="formErrors.newPassword">{{formErrors.newPassword}}</mat-error>
    </mat-form-field>
    <mat-form-field class="full-width-input" appearance="outline">
      <mat-label class="text-field">Confirmar Contraseña</mat-label>
      <input matInput type="password" name="confirmPassword"
             #Input (keyup)="verifyPassword(Input.value)"
             autocomplete="off">
      </mat-form-field>
      <mat-error class="confirm-pass-error" *ngIf="confirmPassMsg !== ''">
        {{confirmPassMsg}}
      </mat-error>
  </div>
  <div class="text-center">
    <div class="form-group pt-2">
      <button mat-raised-button
              class="btn btn-primary"
              type="submit"
              [disabled]="(confirmPassMsg !== '') || changePassForm.invalid">
        Cambiar
      </button>
    </div>
  </div>
</form>